var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEightTon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 200",
    style: {
      enableBackground: "new 0 0 500 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#9AE5FC;}\r\n\t.st1{fill:none;stroke:#4E4868;stroke-width:12;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#4E4868;stroke-width:14;stroke-miterlimit:10;}\r\n\t.st3{fill:#EFDD03;}\r\n\t.st4{fill:#EAE9ED;}\r\n\t.st5{fill:#DBDAE1;}\r\n\t.st6{fill:#4E4868;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 405.6,
    y: 77.3,
    className: "st0",
    width: 22.3,
    height: 13
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.6,18.9h234.9c2.8,0,5,2.2,5,5v110.5H92.6V23.9C92.6,21.1,94.8,18.9,97.6,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.3,48.7V30.5c0-2.9,2.4-5.2,5.3-5c0.5,0,1.1,0.1,1.9,0.1c18.5,1.7,31.3,13.6,36.8,19.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M433.4,73.2v24.7c0,0.9,0.2,1.8,0.6,2.6l3.3,6.1c0.4,0.8,0.6,1.6,0.6,2.5v39.6c0,1.2-1,2.2-2.2,2.2h-17.6 c-1.6-3.2-4.6-8.8-9.5-13c-8.1-7-16.9-6.8-20.9-7.4c-3.6,0-9.7,0.5-17.4,4.5c-0.4,0.2-0.8,0.4-1.1,0.7l-4.8,2.6 c-4.6,3.5-9-2.3-9-5.4v-73c0-0.4,1.1-1.5,2.5-1.5h70.7c1.8,0,3.5,0.6,4.9,1.8l2.4,2c1.9,1.7,3,4.1,3,6.6v4h-4.5h-38.4 c-0.6,0-1.1,0.5-1.1,1.1v24.9c0,0.6,0.4,1.1,0.9,1.3l16,6.6l25.6-0.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 361.2,
    y1: 167.3,
    x2: 218.9,
    y2: 167.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 441.1,
    y1: 167.3,
    x2: 414.1,
    y2: 167.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 120.9,
    y1: 167.3,
    x2: 88.8,
    y2: 167.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 387.9,
    cy: 163.7,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 192.6,
    cy: 163.7,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 145.4,
    cy: 163.7,
    r: 16
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M431.7,126.4L431.7,126.4c-5.3,0-9.5,4.8-9.5,10.6v7.5c0,0.1,0.1,0.2,0.2,0.2h9.4c0.1,0,0.2-0.1,0.2-0.2v-17.9 C431.9,126.5,431.8,126.4,431.7,126.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M98.8,24.3c14.4,0,28.7-0.1,43.1,0c5.4,0,9,3.4,8.8,7.8c-0.2,4.2-3.6,7.1-8.8,7.3c-0.9,0-1.7,0-2.6,0 c-13.5,0-27,0-40.5,0C99,34.5,98.9,29.3,98.8,24.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 103.8,
    className: "st4",
    width: 230.4,
    height: 22.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M451,27.5c0,12.9-8.8,20.9-22.1,21.5c-12.8,0.6-21.8-11.7-21.7-22.3c0.1-9.9,8.9-22.5,23-21.6 C442.4,5.9,451,14.5,451,27.5z M435.1,27.1c-1-3-2.1-6.1-6.2-5.8c-3.7,0.3-5.2,3.1-5.3,6.1c-0.1,3.7,3,5.3,6,5.1 C432.4,32.4,434.9,30.7,435.1,27.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M70.1,174c-5.2,0-8.4-3.1-8.2-8.7c0.1-3.8-0.8-5.4-5-5.2c-5.2,0.2-8.5-2.9-8.9-7.6c-0.4-4.5,3.2-9,8.4-9 c4.5-0.1,5.7-1.5,5.5-5.8c-0.2-3.9,4.4-7.8,8.5-8c3.5-0.2,8.2,4,8.2,8.3c0,4.1,1.2,5.3,5.3,5.6c5.5,0.4,8.7,4.3,8.6,8.9 c-0.2,4.6-3.3,7.4-9.5,7.7c-3.7,0.2-4.2,2.1-4.3,5.1C78.5,170.4,74.7,174,70.1,174z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M221.3,197.3H119.5c-2.4,0-4.4-2.8-4.4-6.2l0,0c0-3.4,2-6.2,4.4-6.2h101.8c2.4,0,4.4,2.8,4.4,6.2l0,0 C225.7,194.5,223.7,197.3,221.3,197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M430.8,197.3H313c-2.8,0-5.1-2.8-5.1-6.2l0,0c0-3.4,2.3-6.2,5.1-6.2h117.8c2.8,0,5.1,2.8,5.1,6.2l0,0 C435.9,194.5,433.6,197.3,430.8,197.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M106.4,197.3H92.7c-3.4,0-6.2-2.8-6.2-6.2l0,0c0-3.4,2.8-6.2,6.2-6.2h13.7c3.4,0,6.2,2.8,6.2,6.2l0,0 C112.6,194.5,109.8,197.3,106.4,197.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEightTon);
export default __webpack_public_path__ + "static/media/eight_ton.493594cb779cc5850a2d00d7bda92612.svg";
export { ForwardRef as ReactComponent };